module.exports = __webpack_public_path__ + "static/media/md-bug.a7d3542a.svg";